import { render, staticRenderFns } from "./shipmentOrderItemRecordPage.vue?vue&type=template&id=6abb3af8&"
import script from "./shipmentOrderItemRecordPage.vue?vue&type=script&lang=js&"
export * from "./shipmentOrderItemRecordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports